// Quick auth debug helper
export const checkAuth = () => {
  try {
    const token = localStorage.getItem('authToken');
    const user = localStorage.getItem('currentUser');
    
    console.log('🔍 Auth Debug:');
    console.log('Token exists:', !!token);
    console.log('Token value:', token ? `${token.substring(0, 20)}...` : 'null');
    console.log('User exists:', !!user);
    
    let parsedUser = null;
    try {
      parsedUser = user ? JSON.parse(user) : null;
    } catch (e) {
      console.error('Error parsing user data:', e);
    }
    
    console.log('User:', parsedUser);
    
    return { token, user: parsedUser };
  } catch (error) {
    console.error('Error in checkAuth:', error);
    return { token: null, user: null };
  }
};

// Check if token is expired
export const isTokenExpired = (token) => {
  if (!token) return true;
  
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.exp * 1000 < Date.now();
  } catch (e) {
    return true;
  }
};

